export default __webpack_public_path__ + "static/media/skirmishers_arrows.1cf27911.jpg";